import React, { useEffect, useRef, useState } from 'react';
import { discernService, IDiscernDetails } from '../discern/discernService';
import { message } from 'antd';
import { globalPrompt } from '@/components/message';

type loaddingType = {
	loading: boolean,
	txt: string
}
//向上滚动组件
export function CarouselInfo() {
	const [isScrolle, setIsScrolle] = useState(false);

	// 滚动速度，值越小，滚动越快
	const speed = 80;
	const warper = useRef<any>();
	const childDom1 = useRef<any>();
	const childDom2 = useRef<any>();
	let timer: NodeJS.Timeout;

	const [dataSource, setDataSource] = useState<IDiscernDetails[]>([]);
	const [loading, setLoading] = useState<loaddingType>({ loading: true, txt: "加载中..." });

	//列表查询
	const loadData = async () => {
		// setLoading({ loading: true, txt: "加载中..." });
		setIsScrolle(false);
		const searchParams = {
			status: "0",
			pageSize: 10,
			pageNum: 1,
		}
		let { retData } = await discernService.page(searchParams);
		const { records, ...pg } = retData;
		setDataSource(records ?? []);
		setIsScrolle(true);
		setLoading({ loading: false, txt: "" });
		return records;
	}

	useEffect(() => {
		loadData();
	}, []);

	// 开始滚动
	useEffect(() => {
		// 多拷贝一层，让它无缝滚动
		childDom2.current.innerHTML = childDom1.current.innerHTML;
		if (isScrolle) {
			timer = setInterval(
				() => {
					warper.current.scrollTop >= childDom1.current.scrollHeight
						? (warper.current.scrollTop = 0)
						: warper.current.scrollTop++
					// console.log(warper.current.scrollTop, childDom1.current.scrollHeight)
				}
				,
				speed
			);
		}
		return () => {
			clearTimeout(timer);
		};
	}, [isScrolle]);

	//标记有用
	const markUseful = async (item: IDiscernDetails) => {
		setLoading({ loading: true, txt: "标记中..." });
		setIsScrolle(false);
		try {
			let { retData } = await discernService.distinguishUpdate({
				id: item.id,
				status: "1",
			})
			retData && loadData();
			message.success("标记成功");
		} catch (err) {
			setLoading({ loading: false, txt: "" });
			setIsScrolle(true);
		}
	};

	//丢弃
	const onCancel = async (id: string) => {
		setLoading({ loading: true, txt: "丢弃中..." });
		setIsScrolle(false);
		try {
			let { retData } = await discernService.distinguishCancel(id);
			retData && loadData();
			message.success("丢弃成功");
		} catch (err) {
			setLoading({ loading: false, txt: "" });
			setIsScrolle(true);
		}
	}

	const hoverHandler = (flag: boolean) => setIsScrolle(flag);

	return (
		<div className='home-content-center-carouselInfo'>
			<div className='carouselInfo-body'>
				<div
					className='parent'
					ref={warper}
					onMouseOver={() => hoverHandler(false)}
					onMouseLeave={() => hoverHandler(true)}
				>
					<ul className='child' ref={childDom1}>
						{dataSource.map((item) => (
							<li key={item.id}>
								<span>{`[${item.bidStartTime ?? ""} ${item.region ?? ""}] ${item.title}`}</span>
								<div>
									<span className="carouselInfo-btn" onClick={() => markUseful(item)}>
										<span className="carouselInfo-border">标记有用</span>
									</span>
									<span className="carouselInfo-btn" onClick={() => globalPrompt("modal", {
										title: "确认丢弃？",
										text: item.title,
										zIndex: 99999,
										onOk: () => onCancel(item.id)
									})}>
										<span className="carouselInfo-border">丢弃</span>
									</span>
								</div>
							</li>
						))}
					</ul>
					<ul className='child' ref={childDom2}></ul>
				</div>
			</div>
			{
				loading.loading && <div className="caseMarronFonce">
					<div className="spinner"></div>
					<div className="spinner-text" style={{ top: "70%" }}>{loading.txt}</div>
				</div>
			}
		</div >
	);
}
